module.exports = __webpack_public_path__ + "static/media/205_SHOT_211.79299dc3.webp";